import { Row, Col } from "antd";
import { Slide } from "react-awesome-reveal";
import { withTranslation } from "react-i18next";

import { ContentBlockProps } from "./types";
import {
    ContentSection,
    StyledImage,
    VerticalStack,
    LeftAlignedContentWrapper,
    ContentHeader,
    ContentText,
    ContentList,
    VerticalLine,

} from "./styles";

const BusinessBlock = ({
    text1,
    text2,
    text3,
    skill1,
    skill2,
    skill3,
    id,
    direction,
}: ContentBlockProps) => {

    return (
        <ContentSection>
            <Slide direction="right" triggerOnce>
                <Row justify="center" align="middle" style={{ position: "relative" }}>
                    <Col lg={12} md={12} sm={24} xs={24} className="left-column">
                        <StyledImage src="/img/Premier One Plus IDS Logo Georgia (Cross).png" alt="Premier One Plus IDS Georgia" />
                    </Col>
                    <VerticalLine />
                    <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'center' }}>
                        <VerticalStack>
                            <LeftAlignedContentWrapper>
                                <ContentHeader>{text1.split("PremierOne Plus IDS").map((part, index, arr) =>
                                    index < arr.length - 1 ? (
                                        <>
                                            {part}
                                            <strong>PremierOne Plus IDS</strong>
                                        </>
                                    ) : (
                                        part
                                    )
                                )}</ContentHeader>
                                <ContentText>{text2}</ContentText>
                                <ContentList>{skill1}</ContentList>
                                <ContentList>{skill2}</ContentList>
                                <ContentList>{skill3}</ContentList>
                                <ContentText>{text3}</ContentText>
                            </LeftAlignedContentWrapper>
                        </VerticalStack>
                    </Col>
                </Row>

            </Slide>
        </ContentSection>
    );
};

export default withTranslation()(BusinessBlock);
